/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteMenuCategoryModel as DigiworkMaitreDPosDtoMenuDeleteMenuCategoryModel } from '../../models/Digiwork/MaitreD/Pos/DTO/Menu/delete-menu-category-model';

export interface DeleteCategory$Params {
      body?: DigiworkMaitreDPosDtoMenuDeleteMenuCategoryModel
}

export function deleteCategory(http: HttpClient, rootUrl: string, params?: DeleteCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteCategory.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteCategory.PATH = '/api/gmn/Menu/deletecategory';
